import styled from 'styled-components';

const TempChatIconSvg = styled.svg`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;

export default function TempChatIcon() {
  return (
    <TempChatIconSvg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10 6.5V10.75L12.75 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10"
        cy="10"
        r="9.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="3 6"
      />
    </TempChatIconSvg>
  );
}
